import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useAuth } from "../auth/context/useAuth";

const PaypalButton = () => {
  const { user, loading: userLoading, processProPurchase } = useAuth();
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "EUR",
    intent: "capture",
  };

  if (!user) {
    return (
      <div>Please log in or register</div>
    )
  }

  if (userLoading) {
    return <div>Loading user...</div>;
  }

  if (status === "loading") {
    return <div>Verifying payment...</div>;
  }

  if (status === "success") {
    return <div className="p-4 bg-green-100 text-green-700 rounded">Payment successful! Welcome to Pro.</div>;
  }

  if (user.isPro) {
    return <div className="p-4 bg-blue-100 text-blue-700 rounded">You are a Pro User.</div>;
  }

  if (status === "error") {
    return (
        <div>
            error
        </div>
    );
  }

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: "0.01",
                },
              },
            ],
          });
        }}
        onApprove={(data, actions) => {
          setStatus("loading");
          setError(null);
          return (async () => {
            try {
              const result = await processProPurchase(data.orderID);

              if (result.success) {
                setStatus("success");
              } else {
                setError("Payment verification failed.");
                setStatus("error");
              }
            } catch (err) {
              console.error("Payment verification error:", err);
              if (err.code === 'functions/failed-precondition') {
                setError(err.message);
              } else {
                setError("An unexpected error occurred during verification.");
              }
              setStatus("error");
            }
          })();
        }}
        onError={(err) => {
            console.error("PayPal Button error:", err);
            setError("An error occurred with the PayPal button.");
            setStatus("error");
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PaypalButton;
